<script setup lang="ts">
import { computed } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="acompanhamento-pagamento-honorarios/pagamento-parcela-honorarios-nao-realizado"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Observação"
        name="observacao"
        :rules="[{ message: 'Observação é obrigatória', required: true }]"
      >
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
